/*
 * Copyright (c) 2023-2025 Yesan SAS
 * All rights reserved
 *
 * The present software is the confidential and proprietary information of
 * Yesan SAS. You shall not disclose the present software and shall
 * use it only in accordance with the terms of the license agreement you
 * entered into with Yesan SAS. This software may be subject to
 * export or import laws in certain countries.
 */
/**
 * Translation
 */
export const translation = {
  "NotFound": "404 - 페이지를 찾을 수 없음",
  "ComingSoon": "곧 출시 예정",
  "YesanPersonalFinance": "Yesan, 개인 금융",
  "Yesan": "Yesan",
  "PersonalFinance": "개인 금융",
  "YesanDownload": "Yesan 다운로드",
  "ThisWebsiteUsesCookies": "당사는 쿠키를 사용하여 사이트 성능 및 사용에 대한 정보를 수집 및 분석하고 소셜 미디어 기능을 제공합니다. 계속 진행하면 쿠키 사용에 동의하는 것입니다.",
  "IGotIt": "OK",
  "BecomeFinanciallyFree": "재정적으로 자유로워지기",
  "inStepsAndActions": "에 동의하는 것으로 간주합니다.",
  "TrackPlanAnalyze": "추적. 계획. 분석하세요.",
  "FTrack": "1. 추적",
  "FPlan": "2. 계획",
  "FAnalyze": "3. 분석",
  "Features": "특징",
  "FeaturesSubHeading": "이미 금융 지식이 있는 순수 초보자라면 재정적으로 자유로워지는 데 필요한 앱입니다.",
  "ManageAccounts": "계좌 관리",
  "CashLiquidFixedAssetsLiabilities": "현금, 유동자산, 고정자산 및 부채.",
  "TrackTransactions": "거래 추적",
  "IncomesExpensesTransferInvestments": "수입, 지출, 이체, 투자.",
  "ImportExport": "가져오기/내보내기",
  "YourDataAlwaysAccessible": "데이터에 항상 액세스하세요.",
  "PlanYourFreedom": "자유를 계획하세요",
  "StepsAwayFromFI": "재정적 독립을 위한 8단계.",
  "BudgetsAndGoals": "예산 및 목표",
  "CheckYourProgressAndAchieve": "진행 상황을 확인하고 재정 목표를 달성하세요.",
  "DashboardAndAnalytics": "대시보드 및 분석",
  "ReviewLearnOptimizeWith": "차트, 인사이트, 도구로 검토, 학습, 최적화하세요.",
  "Security": "보안",
  "MilitaryGradeEncryption": "군사급 암호화, 생체인식 지원, 장치에 저장된 데이터.",
  "OfflineMode": "오프라인 모드",
  "YourDataAlwaysAccessibleAndModif": "데이터에 항상 액세스하고 수정할 수 있습니다.",
  "Track": "추적",
  "Income": "수입",
  "Expense": "비용",
  "Transfer": "송금",
  "transactionsAndManageAccounts": "거래를 추적하고 다양한 계정을 관리하세요:",
  "checkings": "수표",
  "savings": "저축",
  "realEstate": "부동산",
  "stocks": "주식 시장",
  "bonds": "채권",
  "crypto": "암호화폐",
  "notes": "지폐, 현금 지갑",
  "envelopes": "봉투",
  "privateEquity": "사모 펀드",
  "metal": "금속",
  "retirement": "퇴직금",
  "lifeInsurance": "생명 보험",
  "intellectualProperty": "지적 재산",
  "otherLiquidAsset": "기타 유동 자산",
  "otherFixedAsset": "기타 고정 자산",
  "mortgage": "모기지",
  "loan": "소비자 대출",
  "creditCard": "신용 카드",
  "otherLiability": "기타 부채",
  "AccountsManagement": "계정 관리",
  "MultipleAccountsTypesAndGrouping": "여러 계정 유형 및 그룹화",
  "LinkAccounts": "소속 기관의 계정 연결(특정 국가에서만 사용 가능)",
  "SmartAccounts": "스마트 계정",
  "AddEditDeleteTransactions": "거래 추가/수정/삭제",
  "TickVerifiedTransactions": "확인된 거래 체크 표시",
  "CategorizeTransactions": "거래 분류하기",
  "TagTransactions": "거래에 태그 지정",
  "TrackKakeiboType": "가케이보 유형 추적",
  "TrackInvestments": "투자 추적(특정 국가에서만 사용 가능)",
  "ImportFromCSVFile": "CSV 파일에서 전체 또는 증분으로 트랜잭션 가져오기",
  "ExportToCSVFile": "CSV 파일로 거래 내보내기",
  "stepsTowardsFIPlanBudgetingReachGoals": "재정 독립을 향한 8단계 계획, 세부 예산 계획, 재정 목표를 더 빨리 달성하세요.",
  "levelsTowardsFI": "재정적 독립을 향한 8단계",
  "EstablishBudgetsPer": "계정당 예산 설정",
  "account": "계정",
  "accountType": "계정 유형",
  "KakeiboType": "가케이보 유형",
  "category": "카테고리",
  "tag": "태그",
  "label": "라벨",
  "TrackBudgetsPerFrequency": "빈도별 예산 추적",
  "CreateGoalsOnSpendingBalanceCashFlowActions": "지출, 잔액, 현금 흐름, 작업에 대한 목표 만들기",
  "TrackGoalsProgress": "목표 진행 상황 추적",
  "ReviewLearnOptimizeWithReportsCharts": "보고서, 차트, 트렌드, 인사이트, 도구를 사용해 검토, 학습, 최적화하세요.",
  "Dashboard": "대시보드",
  "FSNetWorth": "재무 제표 순자산",
  "FSPnL": "재무 제표: 손익 계산서/손익계산서",
  "FSBalanceSheetAssetsLiabilities": "재무상태표 대차 대조표, 자산, 부채",
  "FSCashFlow": "재무상태표 현금 흐름표, 차변 대변, 현금흐름표",
  "FSFlows": "재무상태표 흐름",
  "FSRatios": "재무상태표 비율",
  "TrendsMonthEnd": "월말 추세: 수입 및 지출, 현금 흐름",
  "TrendsPerformance": "실적 추세: 전년 대비, 전월 대비, 전월 대비",
  "IncomeTrendsPer": "인당 수입 트렌드",
  "SpendingTrendsPer": "항목별 지출 동향",
  "RecurringItemsIE": "반복 항목 수입 및 지출",
  "DebtProgressTrends": "부채 진행 동향",
  "KakeiboMTDReviewTrends": "카케이보 MTD 검토, 지난달, 트렌드",
  "FIWCLE": "재정적 독립: 월별 차트, 생활 에너지별 지출",
  "DebtPaydownSnowballAvalanche": "부채 상환: 눈덩이, 눈사태",
  "FullyCustomizableAnalyticsRange": "완전히 사용자 정의 가능한 분석 시간 범위",
  "ContactUs": "문의하기",
  "Privacy": "개인정보 보호",
  "Terms": "약관",
  "About": "About",
  "IAgreeToThe": "본인은",
  "AndThe": "및",
  "PrivacyPolicy": "개인정보처리방침",
  "TermsOfUse": "이용 약관",

  "DigitalSoftwareExperienceTagline": "현대 사회를 위한 디지털 소프트웨어 경험",
  "DigitalExperience": "디지털 경험",
  "SoftwareForTheModernWorld": "현대 사회를 위한 소프트웨어",
  "MobileApplications": "모바일 애플리케이션",
  "forConnectedAndOfflineHumans": "연결 및 오프라인 인간을 위한 모바일 애플리케이션",
  "CloudSaaS": "클라우드 SaaS",
  "ResponsiveAndWebServices": "반응형 및 웹 서비스",
  "PersonalFinanceServices": "개인 금융 서비스",
  "YS_p1": "Yesan 소비자를 위한 최첨단 모바일 애플리케이션 개발을 전문으로 하는 역동적인 소프트웨어 회사입니다. Yesan 오늘날 기술에 정통한 사용자의 변화하는 요구와 선호도에 대한 깊은 이해를 바탕으로 직관적이고 매력적이며 다양한 기능을 갖춘 모바일 환경을 구축하여 사용자의 삶을 풍요롭게 만드는 데 전념하고 있습니다.",
  "YS_p2": "Yesan 미션의 핵심은 혁신과 창의성을 향한 끊임없는 노력이며, 각 제품은 원활한 기능과 탁월한 사용자 경험을 제공하기 위해 세심하게 제작됩니다.",
  "PersonalFinanceApplication": "개인 금융 애플리케이션",
  "YPF_p1": "Yesan, 개인 금융은 사용자가 손끝으로 편리하게 액세스할 수 있는 종합적인 재무 관리 도구를 제공하도록 설계된 최첨단 개인 금융 모바일 애플리케이션입니다. 세련되고 직관적인 인터페이스를 갖춘 예산, 개인 금융은 모든 수준의 금융 지식이 있는 사용자에게 재정 관리에 대한 총체적인 접근 방식을 제공합니다.",
  "YPF_p2": "주요 기능으로는 예산 추적, 비용 분류, 실시간 거래 모니터링이 있어 사용자가 자신의 지출 습관에 대한 인사이트를 쉽게 얻을 수 있습니다. 이 앱은 또한 사용자 정의 가능한 예산 옵션을 제공하여 사용자가 재정 목표를 설정하고 시간 경과에 따른 진행 상황을 추적할 수 있도록 합니다.",
  "YPF_p3": "또한 Yesan, 개인 금융은 사용자의 민감한 금융 정보를 보호하기 위해 최첨단 암호화 프로토콜을 사용하여 보안을 우선시합니다. 은행 수준의 보안 조치를 통해 사용자는 프라이버시를 침해하지 않고도 안심하고 계정을 연결하고 거래를 동기화할 수 있습니다.",
  "YPF_p4": "Yesan, 개인 금융은 재무 결정을 최적화하기 위해 통찰력 있는 분석과 개인화된 추천을 제공함으로써 기본적인 예산 관리를 뛰어넘습니다. 잠재적인 저축 기회 파악, 투자 포트폴리오 모니터링, 부채 상환 전략 관리 등 이 앱은 사용자가 재무 목표를 달성하는 데 도움이 되는 맞춤형 인사이트를 제공합니다.",
  "Discover": "알아보기",
  "Firstname": "이름",
  "Lastname": "성",
  "Company":"회사",
  "Subject": "제목",
  "Email": "이메일",
  "Message": "메시지",
  "ThankYouForContactingUs": "문의해 주셔서 감사합니다.",
  "ValidFirstnameRequired": "유효한 이름이 필요합니다.",
  "ValidLastnameRequired": "유효한 성이 필요합니다.",
  "ValidEmailAddressRequired": "유효한 이메일 주소를 입력하세요.",
  "ValidSubjectRequired": "올바른 제목을 선택해 주세요.",
  "ValidMessageRequired": "올바른 메시지를 입력하세요.",
  "UnableToSendTheFormPleaseRetryLater": "양식을 보낼 수 없습니다. 나중에 다시 시도하세요.",
  "Information": "정보",
  "Sales":"판매",
  "Support": "지원",
  "Press": "언론",
  "Partnership": "파트너십",
  "Other": "기타",
  "Blog":"블로그",

  "Accept":"수락",
  "Decline":"거절",

  "WorklogCalendar":"Jira용 워크로그 캘린더",

  "DirectlyAccessibleInProjectApps":"프로젝트 앱에서 바로 액세스",
  "VisualizeWhereYouSpentYourTime":"시간을 어디에 사용했는지 시각화",
  "AllYourWorklogsInACalendar":"캘린더의 모든 워크로그",
  "MonthSummary":"월 요약",
  "CheckIfYouForgotToLogTime":"시간 기록을 잊어버렸는지 확인하세요.",
  "DirectlyAccessTheIssuesAndUpdateTime":"이슈에 직접 액세스하여 시간 업데이트",
  "DirectlyAccessTheIssuesAndUpdateTimeDescription":"작업 로그 항목을 클릭하여 이슈에 직접 액세스하고 추적된 시간을 편집하세요.",
  "AlsoAvailableInDarkMode":"다크 모드에서도 사용 가능",
  "DirectlyLogWorkOnTheCalendarVisually":"캘린더에 직접 시각적으로 작업 기록하기",
  "ClickOnTheCalendarToCreateNewWorklog":"캘린더를 클릭하여 새 워크로그를 생성하세요.",

  "AppsForAtlassian":"Atlassian용 앱",
  "YCL_p1":"월, 주, 근무 주, 일 보기를 통해 모든 워크로그를 달력에서 시각화하세요.",
  "YCL_p2":"캘린더에서 시각적으로 시간 슬롯을 선택하여 직접 작업을 기록하세요.",
  "YCL_p3":"작업표의 시간 추적을 잊어버렸는지 확인할 수 있습니다.",
  "YCL_p4":"해당 언어로 제공됩니다: 영어(영국), 영어(미국), 중국어(간체), 중국어(번체), 체코어, 덴마크어, 네덜란드어, 에스토니아어, 핀란드어, 프랑스어, 독일어, 헝가리어, 아이슬란드어, 이탈리아어, 일본어, 한국어, 노르웨이어, 폴란드어, 포르투갈어(브라질), 포르투갈어(포르투갈), 러시아어, 스페인어, 스웨덴어, 터키어.",

  "Kakeibo":"카케이보",
  "Genea":"Genea",
  "FinancialPortfolio":"Jira용 재무 포트폴리오",
  "BringRealFinancialPortfolio":"Jira에 진정한 재무 포트폴리오 관리 기능을 도입하세요. 예산, 자본 지출(CapEx)/운영 지출(OpEx), 프로젝트 비용을 한 곳에서 추적하세요.",
  "YFPAboutQ":"우리의 Jira 프로젝트는 실제로 얼마나 비용이 드나요?",
  "YFPAbout":"Jira용 Financial Portfolio\n재무 담당자와 PMO는 다음과 같은 간단한 질문에 답하기 위해 고심합니다:\n우리의 Jira 프로젝트는 실제로 얼마나 많은 비용이 드는 걸까요?\nJira는 업무를 추적합니다.\n재무 부서는 예산을 관리합니다.\n이 앱은 마침내 이 두 가지를 연결해 줍니다.\n\nFinancial Portfolio는 값비싼 엔터프라이즈 도구 없이도 Jira를 가벼운 PPM + 재무 계획 플랫폼으로 바꿔줍니다.",
  "YFPPorfolioQ":"포트폴리오 예산 및 추적",
  "YFPPorfolioP":"여러 Jira 프로젝트에 걸쳐 포트폴리오를 생성하고 다음을 정의하세요: 예산 금액, 통화, 기간, 포함 프로젝트, 팀. Jira에서 작업이 진행됨에 따라 실제 비용을 자동으로 추적합니다.",
  "YFPPorfolioListQ":"포트폴리오",
  "YFPPorfolioListP":"여러 Jira 프로젝트를 결합한 재무 포트폴리오를 생성하고 다음 정보를 즉시 확인하세요: 예산 대 실제 비용, 실시간 프로젝트 소진율, 자본 지출(CapEx) 대 운영 지출(OpEx) 내역, 이슈 및 프로젝트당 비용, 내보내기 가능한 재무 보고서. 모든 기능은 Jira 작업 로그를 기반으로 직접 구동됩니다.",
  "CostQ":"자동 비용 계산",
  "CostP":"시간 추적을 실제 재무 데이터로 전환하세요. 이 앱은: Jira 작업 로그를 읽고, 시간당 요율을 적용하며, 매일 실제 프로젝트 비용을 계산합니다. 스프레드시트도, 수작업도 필요 없습니다.",
  "RatesQ":"요율",
  "RatesP":"프로젝트별, 팀별, 전체적으로 시간당 요율 설정",
  "ReportQ":"CSV 재무 보고",
  "ReportP":"포트폴리오 재무 데이터를 몇 초 만에 내보내기. 적합한 대상: 재무 팀, CFO 보고, 예산 계획, 감사 지원",
  "SettingsQ":"CapEx 대 OpEx 분류",
  "SettingsP":"회계 및 감사 요건을 지원합니다. 업무를 자본화 가능한 개발(CapEx)과 운영 업무(OpEx)로 분류합니다. 재무 팀이 바로 사용할 수 있는 내보내기 가능한 보고서를 생성합니다."
};

export const documents = {
};
